import "./AdminTableSkeleton.css";

function AdminTableSkeleton({ columns = 8, rows = 10 }) {
  return (
    <div className="admin-table-skeleton" role="status" aria-live="polite">
      <div className="admin-table-skeleton__table">
        <div className="admin-table-skeleton__thead">
          <div className="admin-table-skeleton__row">
            {Array.from({ length: columns }).map((_, i) => (
              <div key={i} className="admin-table-skeleton__th skeleton-pulse" />
            ))}
          </div>
        </div>
        <div className="admin-table-skeleton__tbody">
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <div key={rowIndex} className="admin-table-skeleton__row">
              {Array.from({ length: columns }).map((_, colIndex) => (
                <div
                  key={colIndex}
                  className="admin-table-skeleton__td skeleton-pulse"
                  style={{
                    width: colIndex === 0 ? "18%" : colIndex === columns - 1 ? "12%" : undefined,
                  }}
                />
              ))}
            </div>
          ))}
        </div>
      </div>
      <span className="admin-table-skeleton__sr">Loading table…</span>
    </div>
  );
}

export default AdminTableSkeleton;
